import { useQuery } from "@tanstack/react-query";

const parseWorkerBody = (res) => {
  const body = res?.data ?? res?.body ?? res;
  if (typeof body === "string") {
    try {
      return JSON.parse(body);
    } catch {
      return null;
    }
  }
  return body;
};

export function useGetQualityReport({
  callApiWithWorker,
  datasetId,
  enabled = true,
}) {
  return useQuery({
    queryKey: ["qualityReport", datasetId],
    enabled: Boolean(enabled && callApiWithWorker && datasetId),
    queryFn: async ({ signal }) => {
      const res = await callApiWithWorker(
        `/quality-report/${encodeURIComponent(datasetId)}`,
        {
          method: "GET",
          signal,
        },
      );

      const body = parseWorkerBody(res);
      return body;
    },
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });
}
